import React from 'react'
import '../SASS/sociallink.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faGithub,
  faInstagram,
  faLinkedinIn,
  faTwitter,
} from '@fortawesome/free-brands-svg-icons'

const SocialLink = () => {
  return (
    <div className="leftSide-social-link">
      <div className="links">
        <a target="_blank" rel="noreferrer" href="https://github.com/tehseen01">
          <FontAwesomeIcon icon={faGithub} />
        </a>

        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.instagram.com/tehseen.01/"
        >
          <FontAwesomeIcon icon={faInstagram} />
        </a>

        <a target="_blank" href="/">
          <FontAwesomeIcon icon={faTwitter} />
        </a>

        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.linkedin.com/in/mohd-tehseen-a19825240"
        >
          <FontAwesomeIcon icon={faLinkedinIn} />
        </a>
      </div>
      <div className="line"></div>
      <div className="copyright">
        <span>&copy;/2022</span>
      </div>
    </div>
  )
}

export default SocialLink
